import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Text } from 'rebass/styled-components';

const errorColor = theme('mode', {
  light: (props) => props.theme.colors.deepOrange,
  dark: (props) => props.theme.colors.orange,
});

const ValidationError = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${errorColor};
`;

function EditorError(props) {
  const {
    isValid,
  } = props;

  if (isValid) {
    return null;
  }

  return (
    <ValidationError fontSize={1} data-testid="editor-error">* Please fix the errors outlined below</ValidationError>
  );
}

EditorError.propTypes = {
  isValid: PropTypes.bool.isRequired,
};

export default EditorError;
